import { Outlet } from 'react-router';

import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { useIsDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsDesktopAndAbove';
import { navLabels } from '@sorare/core/src/lib/glossary';
import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

const Layout = () => {
  const isDesktopAndAbove = useIsDesktopAndAbove();
  return (
    <RequireAuth>
      {!isDesktopAndAbove && (
        <PageHeader text={navLabels.home} disableBackBrowser />
      )}
      <Outlet />
    </RequireAuth>
  );
};

export default Layout;
